module.exports = __webpack_public_path__ + "assets/c3498170d2d4ffd1c3b94ff9ee945ba0.jpg";